import { IsPhone } from "./phone";
// 非负浮点数（正浮点数 + 0）验证
const validatorM = (rule, value, callback) => {
  let reg = /^\d+(\.\d+)?$/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入数字"));
  }
};
/* 合法uri*/
const validateURL = (textval) => {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

// 正整数验证
const validatorIndex = (rule, value, callback) => {
  let reg = /^[0-9]*[1-9][0-9]*$/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入正整数"));
  }
};
// 非负整数验证
const validatorIn = (rule, value, callback) => {
  const reg = /^[1-9]\d*$/
  if (reg.test(value) || !value) {
    callback()
  } else {
    callback(new Error('请输入非负整数'))
  }
}
// 3以上的正整数验证
const validatorOver3 = (rule, value, callback) => {
  let reg = /^[3-9]|[1-9]\d+/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入3以上的正整数"));
  }
};
// 非汉字验证
const validatorHanzi = (rule, value, callback) => {
  let reg = /[^\u4e00-\u9fa5]/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入非汉字字符"));
  }
};
// 0～1小数验证
const validatorDecimal = (rule, value, callback) => {
  let reg = /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入0~1的两位小数"));
  }
};
// 数字，字母，汉字校验  只含有汉字、数字、字母、下划线不能以下划线开头和结尾
const validatorLanguage = (rule, value, callback) => {
  let reg = /^[\w\u4E00-\u9FA5\uF900-\uFA2D]*$/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入汉字，字母，数字集合的字符串"));
  }
};
// 版本号规则
const validatorVerName = (rule, value, callback) => {
  let reg = /^[1-9][0-9]{0,}\.[0-9]{1,3}\.[0-9]{1,3}$/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入[正整数].[0~999].[0~999]格式的字符"));
  }
};
// 手机号码规则
const validatorMobile = (rule, value, callback) => {
  if (value && IsPhone(value)) {
    callback();
  } else {
    callback(new Error("请输入带有效的手机号码"));
  }
};

// 手机号码规则2
const validatorMobile2 = (rule, value, callback) => {
  if ((value && IsPhone(value)) || value === "") {
    callback();
  } else {
    callback(new Error("请输入带有效的手机号码"));
  }
};

// 限制只能输入数字(可以输入两位小数)
const validatorFloat = (rule, value, callback) => {
  let reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入最多带两位小数的实数"));
  }
};
// 验证当前number只能为负数
const validatorCutNumber = (rule, value, callback) => {
  if (value <= 0) {
    callback();
  } else {
    callback(new Error("当前金币只能为负数"));
  }
};

// 验证 只能输入数字、英文逗号
const validatorNumber = (rule, value, callback) => {
  let reg = /^[^,](([1-9,])(?!\2))+[^,]$/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入输入数字、英文逗号"));
  }
};

// 作品排序
const validatorWorksSort = (rule, value, callback) => {
  let reg = /^[0-5]$/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入0-5的数字"));
  }
};

// 置顶排序
const validatorLiaoBaTopSort = (rule, value, callback) => {
  let reg = /^([1-9]\d|\d)$/;
  if (reg.test(value) || !value) {
    callback();
  } else {
    callback(new Error("请输入0-99的数字"));
  }
};

// 验证权限
const validatorAuthority = () => {
  const whitelist = ["60d2ea2a798fcb2ea8908ca8", "5f814e536d28214b61f9f677"];
  const id = JSON.parse(localStorage.getItem("userInfo")).admin.id;
  let auth = false;
  whitelist.forEach(i => {
    if (i === id) {
      auth = true;
    }
  })
  return auth;
};

// 时间格式转化
const uniteDate = (tm) => {
  if (!tm) {
    return "-";
  }
  let sjc = new Date(tm);
  let sd = sjc.toLocaleDateString(undefined, {
    hour12: false,
    timeZone: "Asia/Shanghai"
  }) + ' ' + sjc.toLocaleTimeString(undefined, {
    hour12: false,
    timeZone: "Asia/Shanghai"
  });
  let cxk = sd.replace(/ 24/g, " 00");
  let lh = cxk.replace(/\//g, "-");
  return lh;
}

export const isFullURL = (text) => {
  return /^(http(s)?:\/\/)\w+[^\s]+(\.[^\s]+){1,}$/.test(text);
};

export {
  validatorIndex,
  validatorOver3,
  validatorFloat,
  validatorDecimal,
  validatorLanguage,
  validatorHanzi,
  validatorVerName,
  validatorMobile,
  validatorMobile2,
  validatorCutNumber,
  validatorNumber,
  validatorM,
  validatorIn,
  validatorWorksSort,
  validatorAuthority,
  validatorLiaoBaTopSort,
  validateURL,
  uniteDate
};
